import * as React from 'react';
import { Tooltip } from 'react-tooltip';
export const ToolTip = () => {
    return <Tooltip id="icon-set-tooltip" openOnClick={true}/>;
};
ToolTip.displayName = 'ToolTip';
export default ToolTip;
